import React, { useState } from "react";
import CustomerTableOverview from "../components/customers/CustomerTableOverview";

const Customers = () => {
  const [filters, setFilters] = useState({
    fromDate: "",
    toDate: "",
    referralCode: "",
  });

  const [searchTerm, setSearchTerm] = useState("");
  return (
    <div>
      <CustomerTableOverview
        filters={filters}
        setFilters={setFilters}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
      />
    </div>
  );
};

export default Customers;
